import { WAC_CROSSFLOW_PARAMS } from '@townsquare/crossflow/wac';
import { farewellFeedResource } from '@townsquare/discover-view/farewell-feed-resource';
import { loomFeedResource } from '@townsquare/discover-view/loom-feed-resource';
import { popularFeedResource } from '@townsquare/discover-view/popular-feed-resource';
import { welcomeFeedResource } from '@townsquare/discover-view/welcome-feed-resource';
import { homeHeaderViewResource } from '@townsquare/home-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { homeTabRoute as homeTabRouteDefinition } from '@townsquare/routes/hometab-view';
import { v2Resource as threadsV2Resource } from '@townsquare/threads/v2-resource';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { whereYouWorkResource } from '@townsquare/where-you-work/resources';
import { assignedSectionResource } from '@townsquare/work-feeds/resources/assigned';
import { workFeedSectionResource } from '@townsquare/work-feeds/resources/work-feed';

homeTabRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "hometab-view" */ './components/HomeTabView'),
	loading: () => null,
});
homeTabRouteDefinition.resources = [
	titanEapCrossFlowQueryResource,
	homeHeaderViewResource,
	workFeedSectionResource,
	assignedSectionResource,
	onboardingResource,
	popularFeedResource,
	welcomeFeedResource,
	farewellFeedResource,
	loomFeedResource,
	threadsV2Resource,
	whereYouWorkResource,
];
homeTabRouteDefinition.query = [...WAC_CROSSFLOW_PARAMS.map(param => `${param}?`), 'src?', 'cloudId?'];
export const homeTabRoute = homeTabRouteDefinition;
